import axios from 'axios'

export async function getCountries() {
  return (await axios.get('/countries')).data
}
